import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  getMissingConsents,
  getMissingConsentsActionState,
  LoadMissingConsents,
} from '@resident-nx/shared';
import { KeycloakService } from '@resident-nx/web/data-access';
import { filter, tap } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export const consentGuard: CanActivateFn = (_, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const keycloakService = inject(KeycloakService);
  const isConsentRoute = state.url === '/consent';

  // Angular subscribes to all canActivate guards of a route concurrently, so
  // this runs alongside AuthWebGuard rather than after it. Without a token the
  // consent request would fire unauthenticated and fail; leave the redirect to
  // AuthWebGuard, whose result takes precedence.
  if (!keycloakService.token) {
    return true;
  }

  return store.select(getMissingConsentsActionState).pipe(
    tap(state => {
      if (!state.pending && !state.done) {
        store.dispatch(LoadMissingConsents());
      }
    }),
    filter(state => !state.pending && state.done),
    switchMap(() => store.select(getMissingConsents)),
    map(missingConsents => {
      const hasMissingConsents = missingConsents.length > 0;
      if (hasMissingConsents === isConsentRoute) return true;
      return new RedirectCommand(router.parseUrl(hasMissingConsents ? 'consent' : 'dashboard'));
    })
  );
};
